PJQ.views.bidForms.Bidders = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Bidders-Container'),
		subTemplates: {
			bidder: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Bidder')
		},
		numPerPage: 5
	},
	events: {
		'click .bidder-review-proposal': 'reviewProposal',
		'click .bidder-create-proposal': 'createProposal',
		'keyup .bidders-search': 'filterBidders',
		'click .bidders-clear-filters': 'clearFilters',
		'click .bidder-edit': 'editBidder',
		'click .bidder-delete': 'deleteBidder'
	},
	beforeFirstRender: function () {
		this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
		this.listenTo(this.collection, "sync reset change", this.render);
	},
	renderData: function () {
		let searchFilter = this.getSearchFilter().toLowerCase(),
			renderModels = this.collection.models,
			statusFilter = this.getStatusFilter();
		if (_.size(searchFilter) > 0) {
			renderModels = _.filter(renderModels, function (model) {
				return null != _.find(model.contacts.models, function (contact) {
					if (contact.get('email').toLowerCase().indexOf(searchFilter) !== -1)
						return true;
					else if (contact.get('companyName').toLowerCase().indexOf(searchFilter) !== -1)
						return true;
					else if (contact.get('contactName').toLowerCase().indexOf(searchFilter) !== -1)
						return true;
					else {
						let numSearch = PJQ.helpers.formatHelpers.numbersOnly(searchFilter);
						if (_.size(numSearch) === 0)
							return false;
						if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('phone')).indexOf(numSearch) !== -1)
							return true;
						else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('fax')).indexOf(numSearch) !== -1)
							return true;
						else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('cell')).indexOf(numSearch) !== -1)
							return true;
					}
				});
			});
		}

		if (_.size(statusFilter) > 0) {
			renderModels = _.filter(renderModels, function (bidder) {
				return _.find(bidder.contacts.models, function (model) {
					return statusFilter.indexOf(model.get('bidStatus').toLowerCase()) !== -1;
				});
			}, this);
		}

		return {
			models: _.sortBy(renderModels, function (model) {
				return model.get('companyName');
			}),
			project: this.options.project,
			canEdit: this.options.canEdit,
			bidFormId: this.options.bidFormId,
			helpers: PJQ.helpers,
			colClass: this.options.colClass
		};
	},
	afterRender: function () {
		this.statusFilterPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.bidders-status-filter'),
			onChange: _.bind(this.filterBidders, this),
			isMultiple: true,
			noneSelectedText: 'No Filters'
		});
		this.searchBar = this.$('.bidders-search');

		this.renderBidders();
	},
	renderBidders: function () {
		let renderData = this.renderData(),
			pageContainer = this.$('.bidders-data');
		if (renderData.models.length > 0) {
			this.$('.bidders-pagination').pagination({
				dataSource: renderData.models,
				pageSize: 5,
				callback: _.bind(function (data) {
					pageContainer.empty();
					_.each(data, function (bidder) {
						this.renderSubTemplate(true, this.options.subTemplates.bidder, pageContainer, {
							project: this.options.project,
							canEdit: this.options.canEdit,
							canViewProposal: this.options.project != null ? (this.options.settings.isSealedBidContact(PJQ.app.session.user.get('id')) || !this.options.settings.get('isSealBids')) : true,
							canCreateProposal: this.options.project != null ? !this.options.settings.get('isSealBids') : true,
							bidder: bidder,
							bidFormId: renderData.bidFormId
						});
					}, this);
				}, this)
			});
		}
		else {
			new PJQ.Alert(pageContainer, {
				text: "No participants match the search criteria"
			})
		}
	},
	clearFilters: function () {
		this.statusFilterPicker.deselectAll();
		this.searchBar.val('');
		this.filterBidders();
	},
	filterBidders: function () {
		this.statusFilter = this.statusFilterPicker.getValue();
		this.search = this.searchBar.val().trim();
		this.renderBidders();
	},
	getStatusFilter: function () {
		return this.statusFilter ? this.statusFilter : [];
	},
	getSearchFilter: function () {
		return this.search ? this.search : "";
	},
	reviewProposal: function (e) {
		let cid = $(e.currentTarget).closest('.bidder-row').data('cid'),
			proposal = this.collection.get(cid).getProposal(this.options.bidFormId);

		if (proposal) {
			proposal.preview(this.collection, {
				isEdit: false
			});
		}
	},
	createProposal: function (e) {
		let cid = $(e.currentTarget).closest('.bidder-row').data('cid'),
			bidder = this.collection.get(cid);

		let newProposal = new PJQ.models.bidForms.Proposal({
			contactCompanyId: bidder.get('contactCompanyId'),
			groupId: bidder.get('groupId'),
			bidPackageId: bidder.get('bidPackageId'),
			projectId: this.options.project.id,
			bidFormId: bidder.collection.options.bidFormId
		}, {parse: true});
		newProposal.bidder = bidder;
		newProposal.preview(this.collection, {
			isEdit: true
		});
		newProposal.save();
		bidder.proposals.add(newProposal);
		this.collection.trigger('change');
	},
	editBidder: function (e) {
		let cidCompany = $(e.currentTarget).closest('.bidder-row').data('cid'),
			cidContact = $(e.currentTarget).closest('.bidder-contact-container').data('cid'),
			company = this.collection.get(cidCompany),
			contact = company.contacts.get(cidContact);

		new PJQ.views.contacts.BaseEditContactModal({
			model: contact,
			onSave: _.bind(function () {
				company.set('companyName', contact.get('companyName'));
				this.renderBidders();
			}, this)
		});
	},
	deleteBidder: function (e) {
		let cidCompany = $(e.currentTarget).closest('.bidder-row').data('cid'),
			cidContact = $(e.currentTarget).closest('.bidder-contact-container').data('cid'),
			company = this.collection.get(cidCompany),
			contact = company.contacts.get(cidContact);

		new PJQ.views.modals.DeleteCancel({
			header: "Delete Participant",
			body: "Are you sure you want to remove this bid participant from the project?",
			onDelete: _.bind(function () {
				contact.destroy();
				if (_.size(company.contacts) <= 1) {
					this.collection.remove(company);
				}
				this.renderBidders();
			}, this)
		});
	}
});